import React, { PureComponent, Fragment } from "react";
import PropTypes from "prop-types";
import R from "ramda";
import classNames from "classnames";
import { Button, Progress, Alert } from "@simpleryo/syw-uikit";
import { validateField, getBreakRuleMessage } from "../validators";

class ScanPhoto extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      error: ""
    };
  }

  validate = file => {
    const { rules } = this.props;
    const validateValue = {
      type: file.type,
      size: file.size
    };
    return validateField(rules, validateValue);
  };

  handleFileChange = event => {
    const { target } = event;
    const { files } = target;
    const { onChange = R.F } = this.props;

    const error = this.validate(files[0]);
    if (error) {
      return this.setState({ error });
    }

    this.setState({ error });
    return onChange(files[0]);
  };

  render() {
    const { className, name, label, rules, hint, progress = {} } = this.props;
    const errorMsg = this.state.error
      ? getBreakRuleMessage(rules, this.state.error)
      : undefined;
    return (
      <Fragment>
        <Button
          size="small"
          className={className}
          disabled={progress.status === "active"}
        >
          {label}
          <input
            id={name}
            type="file"
            className="upload-file__input"
            onChange={this.handleFileChange}
          />
        </Button>

        {hint && <p className="small form-group__message">{hint}</p>}

        {errorMsg && <Alert message={errorMsg} type="error" showIcon />}

        {!errorMsg &&
          R.not(R.isEmpty(progress)) && (
            <div
              className={classNames("margin-top-20", {
                "has-error": progress.status === "exception"
              })}
            >
              <Progress percent={progress.percent} status={progress.status} />

              {progress.message && (
                <p className="small form-group__message">{progress.message}</p>
              )}
            </div>
          )}
      </Fragment>
    );
  }
}

ScanPhoto.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  rules: PropTypes.array,
  hint: PropTypes.string,
  progress: PropTypes.object,
  onSuccess: PropTypes.func,
  onChange: PropTypes.func,
  className: PropTypes.string
};

export default ScanPhoto;
